import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, NavX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XButton, XDiv, XImage, XScroll, XText } from "IZOX/_X";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import PANoti from "./PANoti";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PAMenu extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      mobileMenu: GFunc.Load("mobileClass") ?? "Insurance"
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAMenu.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toPage = (url) => {
    let {history} = this.props;
    NavX.Goto(history, url);
  }

  _toLogout = () => {
    let {history} = this.props;
    GFunc.Logout();
    NavX.Goto(history, "/Logout");
  }

  renderBtn(func, icon, text, isPage = false, isSVG = true){
    return (
      <XButton height={24} padding={0} round={0} fullWidth
        onPress={func}
        bgColor={ColorX.CSS(isPage ? "LightGrass" : "pureWhite", isPage ? 0.3: 1)}
        color={ColorX.CSS(isPage ? "Axit" : "Gray4")}>
        <HStack spacing={5}>
          <XDiv width={3} fullHeight bgColor={ColorX.CSS(isPage ? "Axit" : "transparent")} />
          <XImage source={icon} width={21} height={20} p={1}
            SVGColor={isSVG ? (isPage ? ColorX.CSS("Axit") : ColorX.CSS("Gray4")) : undefined}
            />
          <XText style={{flex: 1}} fontSize={12}>
            {LocaleX.Parse(text)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderBtnM(func, icon, text, isPage = false, isSVG = true){
    return (
      <XButton round={0} fitWidthToContent
        onPress={func} p={0} 
        bgColor={ColorX.CSS(isPage ? "LightGrass" : "pureWhite", isPage ? 0.3: 1)}
        color={ColorX.CSS(isPage ? "Axit" : "Gray4")}>
        <VStack spacing={5} fitWidthToContent HAlign="|" VAlign="-" pT={5}>
          <HStack fitWidthToContent spacing={5} pH={10}>
            <XImage width={16} height={16} p={1} source={icon} 
              SVGColor={isSVG ? (isPage ? ColorX.CSS("Axit") : ColorX.CSS("Gray4")) : undefined}
              noResize/>
            <XText fontSize={12} noWrap>
              {LocaleX.Parse(text)}
            </XText>
          </HStack>
          <XDiv height={2} fullWidth bgColor={ColorX.CSS(isPage ? "Axit" : "transparent")} />
        </VStack>
      </XButton>
    );
  }


  renderMenuBtn(page, icon, text, isSVG = true){
    let {history} = this.props;
    let {location} = history ?? {};
    let {pathname} = location ?? {};
    let isPage = pathname === page;
    return this.renderBtn(() => this._toPage(page), icon, text, isPage, isSVG);
  }

  renderMenuBtnM(page, icon, text){
    let {history} = this.props;
    let {location} = history ?? {};
    let {pathname} = location ?? {};
    let isPage = pathname === page;
    return this.renderBtnM(() => this._toPage(page), icon, text, isPage);
  }

  renderHeadline(text){
    return (
      <HStack pH={8}>
        <XText color={ColorX.CSS("Leaf")} bold fontSize={16} fullWidth>
          {LocaleX.Parse(text)}
        </XText>
      </HStack>
    );
  }

  renderUpMenu(){
    return (
      <VStack fullWidth>
        {this.renderHeadline({
          EN: "Insurance",
          TC: "保險"
        })}
        {this.renderMenuBtn(
          "/Agent/Dashboard",
          "/Images/Menu/dashboard.svg",
          {
            EN: "Dashboard",
            TC: "概覽"
          }
        )}
        {this.renderMenuBtn(
          "/Agent/AllPolicies",
          "/Images/Menu/allpolicies.svg",
          {
            EN: "All policies",
            TC: "所有保單"
          }
        )}
        {this.renderMenuBtn(
          "/Agent/Claim",
          "/Images/Menu/claim.svg",
          {
            EN: "Claim",
            TC: "理賠"
          }
        )}
        {this.renderMenuBtn(
          "/Agent/ClientManagement",
          "/Images/Menu/client.svg",
          {
            EN: "Clients",
            TC: "客戶"
          }
        )}
        {this.renderMenuBtn(
          "/Agent/MaidManagement",
          "/Images/Menu/helper.svg",
          {
            EN: "Helpers",
            TC: "家務助理"
          }
        )}
        {this.renderMenuBtn(
          "/Agent/MonthlyPayment",
          "/Images/Menu/monthly.svg",
          {
            EN: "Monthly Payment",
            TC: "每月繳費"
          }
        )}
        {this.renderMenuBtn(
          "/Agent/ACP",
          "/Images/Menu/monthly.svg",
          {
            EN: "ACP",
            TC: "ACP"
          }
        )}
      </VStack>
    );
  }

  renderBottomMenu(){
    return(
      <VStack mT={20} fullWidth>
        {this.renderHeadline({
          EN: "Account",
          TC: "帳號"
        })}
        {this.renderMenuBtn(
          "/Agent/AccountInfo",
          "/Images/Icons/ic_account.svg",
          {
            EN: "Account Information",
            TC: "帳號資料"
          },
          false
        )}
      </VStack>
    );
  }

  renderNormal(){
    return (
      <VStack bgColor={ColorX.CSS("pureWhite")} width={157} 
        HAlign="[" pV={16} spacing={4}>
        {this.renderUpMenu()}
        {this.renderBottomMenu()}
        <HStack pT={20}>
          {this.renderMenuBtn(this._toLogout,
            "/Images/Icons/ic_logout.svg",
            {
              EN: "Log out",
              TC: "登出"
            }, false, false)
          }
        </HStack>
      </VStack>
    );
  }

  setMobileMenu = (page) => {
    GFunc.Save("mobileClass", page);
    this.setState({
      mobileMenu: page
    });
  }

  renderTitleBtn(page, label, icon, useAxit = false){
    let {mobileMenu} = this.state;
    let inPage = mobileMenu === page;
    let color = useAxit ? "Axit" : "Leaf";
    return (
      <XButton onPress={() => this.setMobileMenu(page)} notInjectColor flexGrow={1} flexBasis={1}
        bgColor={ColorX.CSS(inPage ? color : "transparent")} round={0} pV={4} pH={10}>
        <HStack spacing={5}>
          {icon?.(inPage)}
          <XText bold fontSize={12} color={ColorX.CSS(inPage ? "pureWhite": color)}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderTitleMenuM(){
    return (
      <HStack HAlign="[">
        {this.renderTitleBtn("Insurance", {
          EN: "Insurance",
          TC: "保險"
        })}
        {this.renderTitleBtn("Personal", {
          EN: "Personal",
          TC: "個人"
        })}
        {this.renderTitleBtn("Notification", {
          EN: "Notification",
          TC: "通知"
        }, 
        (inPage) => <XImage source={inPage ? "/Images/Icons/ic_bell_w.svg" : "/Images/Icons/ic_bell.svg"}/>, true)}
        <XButton onPress={this._toLogout} p={5} width={30}>
          <XImage source={"/Images/Icons/logout_m.svg"}/>
        </XButton>
      </HStack>
    );
  }

  renderPageMenuM(){
    let {mobileMenu} = this.state;
    switch(mobileMenu){
      default: case "Insurance":
        return (
          <XScroll fullWidth mT={8}>
            <HStack HAlign="[" fitWidthToContent>
              {this.renderMenuBtnM(
                "/Agent/Dashboard",
                "/Images/Icons/ic_dashboard.svg",
                {
                  EN: "Dashboard",
                  TC: "概覽"
                }
              )}
              {this.renderMenuBtnM(
                "/Agent/AllPolicies",
                "/Images/Icons/ic_policy.svg",
                {
                  EN: "All policies",
                  TC: "所有保單"
                }
              )}
              {this.renderMenuBtnM(
                "/Agent/Claim",
                "/Images/Icons/ic_claim.svg",
                {
                  EN: "Claim",
                  TC: "理賠"
                }
              )}
              {this.renderMenuBtnM(
                "/Agent/ClientManagement",
                "/Images/Icons/ic_client.svg",
                {
                  EN: "Clients",
                  TC: "客戶"
                }
              )}
              {this.renderMenuBtnM(
                "/Agent/MaidManagement",
                "/Images/Icons/ic_maid.svg",
                {
                  EN: "Helpers",
                  TC: "家務助理"
                }
              )}
              {this.renderMenuBtnM(
                "/Agent/MonthlyPayment",
                "/Images/Icons/ic_policy.svg",
                {
                  EN: "Monthly Payment",
                  TC: "每月繳費"
                }
              )}
              {this.renderMenuBtnM(
                "/Agent/ACP",
                "/Images/Icons/ic_policy.svg",
                {
                  EN: "ACP",
                  TC: "ACP"
                }
              )}
            </HStack>
          </XScroll>
        );
      case "Personal":
        return (
          <XScroll fullWidth mT={8}>
            <HStack HAlign="[" fitWidthToContent>
              {this.renderMenuBtnM(
                "/Agent/AccountInfo",
                "/Images/Icons/ic_account.svg",
                {
                  EN: "Account Information",
                  TC: "帳號資料"
                }
              )}
            </HStack>
          </XScroll>
        );
      case "Notification":
        return <PANoti />;
    }
  }

  renderMobile(){
    return (
      <VStack fullWidth bgColor={ColorX.CSS("pureWhite")} VAlign="^">
        {this.renderTitleMenuM()}
        {this.renderPageMenuM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal(),
    });
  }

}

export default withRouter(observer(PAMenu));
